import { AgsExportHistory } from 'Components/Ags/Core/AgsExportHistory';
import FixedAgsWorkOrderHeader from 'Components/Ags/WorkOrder/Core/FixedHeader/FixedAgsWorkOrderHeader';
import { WorkOrderHeader } from 'Components/Ags/WorkOrder/Core/WorkOrderHeader';
import WorkOrderRunAgsExportSection from 'Components/Ags/WorkOrder/Core/WorkOrderRunAgsExportSection/WorkOrderRunAgsExportSection';
import { Message, Spinner } from 'Components/Core';
import ErrorBoundary from 'Components/Core/ErrorBoundary';
import { PageSection } from 'Components/Layout';
import Page from 'Components/Pages/Core/Page';
import { actions } from 'Data/ReduxViewModels/Ags/WorkOrder';
import { actions as appActions } from 'Data/ReduxViewModels/App';
import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { hasNonEmptyValue } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import './WorkOrderPage.scss';

const WorkOrderPage: React.FC = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const workOrderUUID = params.workOrderId?.toLowerCase();

  const ready = useSelector((state) => state.agsWorkOrderExport.status.ready);
  const errorMessage = useSelector((state) => state.agsWorkOrderExport.status?.errorMessage);
  const tableData = useSelector((state) => state.agsWorkOrderExport.exportHistory, deepEquals);
  const workOrderId = useSelector((state) => state.agsWorkOrderExport.workOrderDetails.WorkOrderId);
  const agsPermission = useSelector((state) => state.user.data?.Claims && state.user.data?.Claims['sq.ags.export']);

  useEffect(() => {
    dispatch(actions.init({ workOrderId: workOrderUUID! }));
  }, [dispatch, workOrderUUID]);

  const pageTitle = ready ? [workOrderId, 'AGS Data'].filter(hasNonEmptyValue).join(' - ') : undefined;
  useEffect(() => {
    if (hasNonEmptyValue(pageTitle)) dispatch(appActions.setPageTitle({ pageTitle, source: TitleSource.Specific }));
    return () => {
      dispatch(appActions.setPageTitle({ pageTitle: undefined, source: TitleSource.Specific }));
    };
  }, [dispatch, pageTitle]);

  if (!ready) {
    return (
      <Page>
        <Spinner large />
      </Page>
    );
  } else if (errorMessage) {
    return (
      <Page>
        <PageSection>
          <Message error>{errorMessage}</Message>
        </PageSection>
      </Page>
    );
  }

  return (
    <Page>
      <div className="WorkOrderPage">
        <ErrorBoundary>
          <FixedAgsWorkOrderHeader />
          <div className="WorkOrderPage-Content">
            <WorkOrderHeader />
            {agsPermission && <WorkOrderRunAgsExportSection />}
            <AgsExportHistory
              colWidths={['0', '0', '10%', '23%', '13%', '44%', '10%']}
              minColWidths={['0', '0', '40px', '135px', '80px', '10px', '40px']}
              name="WorkOrder-ExportHistory"
              data={tableData}
              withDateRange={false}
            />
          </div>
        </ErrorBoundary>
      </div>
    </Page>
  );
};

export default WorkOrderPage;
